import {
  SEARCH_INIT,
  FETCH_SEARCH_START,
  FETCH_SEARCH_END,
  FETCH_SEARCH_MORE_END,
  DELETE_SEARCH_HISTORY,
  FETCH_HOT_WORDS,
} from '../constants';

function addHistory(history, item) {
  if (!history) return [item]
  const inx = history.indexOf(item)
  if (inx === -1) {
    history.unshift(item)
  } else {
    history.splice(inx, 1)
    history.unshift(item)
  }
  if (history.length > 6) history.pop()
  return history
}

export default function search(state = {
  searchResult: {},
  searchResultHasMore: true,
  searchItem: '',
  isSearching: false,
  searchHistory: [],
  hotWords: [],
}, action) {
  switch (action.type) {
    case SEARCH_INIT:
      return {
        ...state,
        searchHistory: action.searchHistory,
      }
    case FETCH_SEARCH_START:
      return {
        ...state,
        isSearching: true,
        searchItem: action.item,
        searchHistory: addHistory(state.searchHistory, action.item),
      }
    case FETCH_SEARCH_END:
      return {
        ...state,
        isSearching: false,
        searchResult: action.data,
        searchResultHasMore: action.data.courses.length === 20,
      }
    case FETCH_SEARCH_MORE_END:
      return {
        ...state,
        searchResult: {
          courses: state.searchResult.courses.concat(action.data.courses),
        },
        searchResultHasMore: action.data.courses.length === 20,
      }
    case DELETE_SEARCH_HISTORY:
      return {
        ...state,
        searchHistory: [],
      }
    case FETCH_HOT_WORDS:
      return {
        ...state,
        hotWords: action.data,
      }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/search.js